import React from "react";
import "./ProgramList.scss";
import ProgramItem from "../ProgramItem";

export default function ProgramList({ history, programs, removeProgram, from }) {
  
  return (
    <div className="c-exercise-list">
      {
        programs && programs.map((program, idx) => (
          <ProgramItem key={idx} history={history} from={from} program={program} idx={idx} removeProgram={removeProgram} />
        ))
      }
    </div>
  );
}
